module.exports = __webpack_public_path__ + "static/media/Wolves927_1c.5f81d13e.svg";